<template>
  <Head>
    <title>{{ title || $t('general.meta.default_title') }}</title>
    <meta name="description" :content="description || wtGeneral('meta', 'defaultDescription')" />
  </Head>
</template>

<script lang="ts" setup>
import { Head } from '@vueuse/head'
import { useWidgetText } from '@/helpers/useWidgetText'

const { wt: wtGeneral } = useWidgetText('widget-texts-general')

defineProps<{
  title?: string
  description?: string
}>()
</script>
